    import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import App from './App';
import './index.css';

// Temporarily disable StrictMode to prevent multiple GoTrueClient instances
// StrictMode causes components to mount twice in development, which can break Supabase auth
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <SubscriptionProvider>
      <App />
    </SubscriptionProvider>
  </BrowserRouter>
);